import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-86c9a65c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-minus" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))

import { computed } from "vue";
import type { SizeType } from "ant-design-vue/es/config-provider";

interface Props {
  modelValue?: number;
  min?: number;
  max?: number;
  step?: number;
  disabled?: boolean;
  size?: SizeType;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'QuantitySelector',
  props: {
    modelValue: { default: 1 },
    min: { default: 1 },
    max: { default: 999 },
    step: { default: 1 },
    disabled: { type: Boolean, default: false },
    size: { default: "middle" }
  },
  emits: ["update:modelValue", "change", "blur"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const clamp = (val: number) => {
  let next = Number.isFinite(val) ? val : props.min;
  if (next < props.min) next = props.min;
  if (next > props.max) next = props.max;
  return next;
};

const innerValue = computed({
  get: () => clamp(props.modelValue ?? props.min),
  set: (val: number | null) => {
    const next = clamp(val ?? props.min);
    emit("update:modelValue", next);
    emit("change", next);
  },
});

const decrease = () => {
  innerValue.value = clamp(innerValue.value - props.step);
};

const increase = () => {
  innerValue.value = clamp(innerValue.value + props.step);
};

const onBlur = (e: FocusEvent) => emit("blur", e);

return (_ctx: any,_cache: any) => {
  const _component_h_button = _resolveComponent("h-button")!
  const _component_a_input_number = _resolveComponent("a-input-number")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ant-qty-selector", [`ant-qty-selector--${_ctx.size}`]])
  }, [
    _createVNode(_component_h_button, {
      type: "text",
      class: "ant-qty-selector__btn",
      disabled: _ctx.disabled || innerValue.value <= _ctx.min,
      onClick: decrease
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["disabled"]),
    _createVNode(_component_a_input_number, {
      value: innerValue.value,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((innerValue).value = $event)),
      min: _ctx.min,
      max: _ctx.max,
      step: _ctx.step,
      disabled: _ctx.disabled,
      controls: false,
      precision: 0,
      class: "ant-qty-selector__input",
      onBlur: onBlur
    }, null, 8, ["value", "min", "max", "step", "disabled"]),
    _createVNode(_component_h_button, {
      type: "text",
      class: "ant-qty-selector__btn",
      disabled: _ctx.disabled || innerValue.value >= _ctx.max,
      onClick: increase
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["disabled"])
  ], 2))
}
}

})